import clsx from "clsx";
import { CSSProperties, ReactNode } from "react";

import RLCardContent from "./RLCardContent";
import RLCardHeader from "./RLCardHeader";
import RLCardLinkHeader from "./RLCardLinkHeader";
import RLCardHeaderPagination from "./RLCardHeaderPagination";
import RLCardHeaderLink from "./RLCardHeaderLink";
import RLCardNoData from "./RLCardNoData";

import styles from "./rlcard.module.scss";
import TableHeaderNavigation from "../../modules/network/components/common/TableHeaderNavigation";

interface RLCardProps {
  id?: string;
  header?: ReactNode;
  content?: ReactNode;
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
}

const RLCard = ({
  id,
  header,
  content,
  className,
  style,
  "data-testid": dataTestId
}: RLCardProps) => (
  <div
    id={id}
    style={style ?? {}}
    className={`${clsx(styles.rlcard, className)}`}
    data-testid={dataTestId}
  >
    {header}
    {content}
  </div>
);

RLCard.Header = RLCardHeader;
RLCard.HeaderNavigation = TableHeaderNavigation;
RLCard.LinkHeader = RLCardLinkHeader;
RLCard.Content = RLCardContent;
RLCard.HeaderPagination = RLCardHeaderPagination;
RLCard.HeaderLink = RLCardHeaderLink;
RLCard.NoData = RLCardNoData;
export default RLCard;
